<template>
<div class="chapter">
<div class="inner_page">
<a id="page_ix"></a>
<h2 class="fm-title"><span class="bold">Abbreviations</span></h2>
<p class="abb1"><span class="abb2">AAMC</span> Australian Army Medical Corps</p>
<p class="abb1"><span class="abb2">AANS</span> Australian Army Nursing Service</p>
<p class="abb1"><span class="abb2">AASC</span> Australian Army Service Corps</p>
<p class="abb1"><span class="abb2">AB</span> Bachelor of Arts</p>
<p class="abb1"><span class="abb2">ADC</span> Aide-de-Camp</p>
<p class="abb1"><span class="abb2">ADMS</span> Assistant Director Medical Services</p>
<p class="abb1"><span class="abb2">ADS</span> Advanced Dressing Station</p>
<p class="abb1"><span class="abb2">AE</span> Australian Engineers</p>
<p class="abb1"><span class="abb2">AEME</span> Australian Electrical and Mechanical Engineers</p>
<p class="abb1"><span class="abb2">AFA</span> Australian Field Artillery</p>
<p class="abb1"><span class="abb2">AFC</span> Air Force Cross or Australian Flying Corps</p>
<p class="abb1"><span class="abb2">AIF</span> Australian Imperial Force</p>
<p class="abb1"><span class="abb2">AM</span> Member of the Order of Australia</p>
<p class="abb1"><span class="abb2">AMF</span> Australian Military Forces</p>
<p class="abb1"><span class="abb2">AMF(L)</span> ACE (Allied Command Europe) Mobile Force (Land)</p>
<p class="abb1"><span class="abb2">ARICS</span> Associate Royal Institute of Chartered Surveyors</p>
<p class="abb1"><span class="abb2">ASC</span> Army Service Corps</p>
<p class="abb1"><span class="abb2">AT</span> Auxiliary Transport</p>
<p class="abb1"><span class="abb2">Att’d</span> Attached</p>
<p class="abb1"><span class="abb2">BA</span> Bachelor of Arts</p>
<p class="abb1"><span class="abb2">BD</span> Bachelor of Divinity</p>
<p class="abb1"><span class="abb2">BEF</span> British Expeditionary Force</p>
<p class="abb1"><span class="abb2">BM</span> Brigade Major</p>
<p class="abb1"><span class="abb2">Brig Gen</span> Brigadier General</p>
<p class="abb1"><span class="abb2">BSc</span> Batchelor of Science</p>
<p class="abb1"><span class="abb2">BSM</span> Battery Sergeant Major</p>
<p class="abb1"><span class="abb2">Bty</span> Battery (artillery unit of 4–8 guns)</p>
<p class="abb1"><span class="abb2">CAMC</span> Canadian Army Medical Corps</p>
<p class="abb1"><span class="abb2">Capt</span> Captain</p>
<p class="abb1"><span class="abb2">CASC</span> Canadian Army Service Corps</p>
<p class="abb1"><span class="abb2">CB</span> Companion of the Order of the Bath or Confined to Barracks</p>
<p class="abb1"><span class="abb2">CBE</span> Commander of the Order of the British Empire</p>
<p class="abb1"><span class="abb2">CCS</span> Casualty Clearing Station</p>
<p class="abb1"><span class="abb2">CD</span> Canadian Forces Decoration</p>
<a id="page_x"></a>
<p class="abb1"><span class="abb2">CE</span> Canadian Engineers</p>
<p class="abb1"><span class="abb2">CEF</span> Canadian Expeditionary Force</p>
<p class="abb1"><span class="abb2">CEO</span> Chief Executive Officer</p>
<p class="abb1"><span class="abb2">CFA</span> Canadian Field Artillery</p>
<p class="abb1"><span class="abb2">CGA</span> Canadian Garrison Artillery</p>
<p class="abb1"><span class="abb2">CH</span> Companion of Honour</p>
<p class="abb1"><span class="abb2">ChD</span> Chirurgiae Doctor, Doctor of Surgery</p>
<p class="abb1"><span class="abb2">CIE</span> Companion of the Order of the Indian Empire</p>
<p class="abb1"><span class="abb2">CIGS</span> Chief of the Imperial General Staff</p>
<p class="abb1"><span class="abb2">C-in-C</span> Commander-in-Chief</p>
<p class="abb1"><span class="abb2">CMF</span> Citizen Military Forces</p>
<p class="abb1"><span class="abb2">CMG</span> Companion of the Order of St Michael &amp; St George</p>
<p class="abb1"><span class="abb2">CMGC</span> Canadian Machine Gun Corps</p>
<p class="abb1"><span class="abb2">CMS</span> Church Missionary Society</p>
<p class="abb1"><span class="abb2">CO</span> Commanding Officer</p>
<p class="abb1"><span class="abb2">Col</span> Colonel</p>
<p class="abb1"><span class="abb2">Cpl</span> Corporal</p>
<p class="abb1"><span class="abb2">CQMS</span> Company Quartermaster Sergeant</p>
<p class="abb1"><span class="abb2">CRA</span> Commander Royal Artillery</p>
<p class="abb1"><span class="abb2">CRE</span> Commander Royal Engineers</p>
<p class="abb1"><span class="abb2">CSgt</span> Colour Sergeant</p>
<p class="abb1"><span class="abb2">CSI</span> Companion of the Order of the Star of India</p>
<p class="abb1"><span class="abb2">CSM</span> Company Sergeant Major</p>
<p class="abb1"><span class="abb2">CStJ</span> Commander of the Most Venerable Order of the Hospital of Saint John of Jerusalem</p>
<p class="abb1"><span class="abb2">Cty</span> Cemetery</p>
<p class="abb1"><span class="abb2">CVO</span> Commander of the Royal Victorian Order</p>
<p class="abb1"><span class="abb2">CWGC</span> Commonwealth War Graves Commission</p>
<p class="abb1"><span class="abb2">CWM</span> Chartered Wealth Manager</p>
<p class="abb1"><span class="abb2">DADMS</span> Deputy Assistant Director Medical Services</p>
<p class="abb1"><span class="abb2">DCM</span> Distinguished Conduct Medal</p>
<p class="abb1"><span class="abb2">DEMS</span> Defensively Equipped Merchant Ships</p>
<p class="abb1"><span class="abb2">DFC</span> Distinguished Flying Cross</p>
<p class="abb1"><span class="abb2">DJStJ</span> Dame of Justice of the Most Venerable Order of the Hospital of</p>
<p class="abb1"><span class="abb2">Saint</span> John of Jerusalem</p>
<p class="abb1"><span class="abb2">DL</span> Deputy Lieutenant</p>
<p class="abb1"><span class="abb2">DSO</span> Distinguished Service Order</p>
<p class="abb1"><span class="abb2">Dvr</span> Driver</p>
<p class="abb1"><span class="abb2">EFTS</span> Elementary Flying Training School</p>
<p class="abb1"><span class="abb2">FCSI</span> Fellow of the Chartered Institute of Securities and Investments</p>
<p class="abb1"><span class="abb2">FM</span> Field Marshal</p>
<p class="abb1"><span class="abb2">FRGS</span> Fellow of the Royal Geographical Society</p>
<a id="page_xi"></a>
<p class="abb1"><span class="abb2">FRICS</span> Fellow Royal Institution of Chartered Surveyors</p>
<p class="abb1"><span class="abb2">GC</span> George Cross</p>
<p class="abb1"><span class="abb2">GCB</span> Knight Grand Cross of the Order of the Bath</p>
<p class="abb1"><span class="abb2">GCMG</span> Knight Grand Cross of the Order of St Michael &amp; St George</p>
<p class="abb1"><span class="abb2">GCVO</span> Knight/Dame Grand Cross of the Royal Victorian Order</p>
<p class="abb1"><span class="abb2">Gen</span> General</p>
<p class="abb1"><span class="abb2">GHQ</span> General Headquarters</p>
<p class="abb1"><span class="abb2">GOC</span> General Officer Commanding</p>
<p class="abb1"><span class="abb2">GOC-in-C</span> General Officer Commanding in Chief</p>
<p class="abb1"><span class="abb2">GSO1,2 or 3</span> General Staff Officer Grade 1 (Lt Col), 2 (Maj) or 3 (Capt)</p>
<p class="abb1"><span class="abb2">HE</span> High Explosive</p>
<p class="abb1"><span class="abb2">HLI</span> Highland Light Infantry</p>
<p class="abb1"><span class="abb2">HMAT</span> Her/His Majesty’s Australian Transport/Troopship</p>
<p class="abb1"><span class="abb2">HMCS</span> Her/His Majesty’s Canadian Ship</p>
<p class="abb1"><span class="abb2">HMHS</span> Her/His Majesty’s Hospital Ship</p>
<p class="abb1"><span class="abb2">HMNZHS</span> His Majesty’s New Zealand Hospital Ship</p>
<p class="abb1"><span class="abb2">HMNZT</span> Her/His Majesty’s New Zealand Transport/Troopship</p>
<p class="abb1"><span class="abb2">HMS</span> Her/His Majesty’s Ship</p>
<p class="abb1"><span class="abb2">HMT</span> Her/His Majesty’s Transport/Troopship/Hired Military Transport</p>
<p class="abb1"><span class="abb2">HQS</span> Headquarters Ship</p>
<p class="abb1"><span class="abb2">HRH</span> His/Her Royal Highness</p>
<p class="abb1"><span class="abb2">HS</span> Hospital Ship</p>
<p class="abb1"><span class="abb2">HT</span> Hired Transport</p>
<p class="abb1"><span class="abb2">IC</span> In Charge/Command</p>
<p class="abb1"><span class="abb2">IRA</span> Irish Republican Army</p>
<p class="abb1"><span class="abb2">IWGC</span> Imperial War Graves Commission</p>
<p class="abb1"><span class="abb2">JP</span> Justice of the Peace</p>
<p class="abb1"><span class="abb2">KBE</span> Knight Commander of the Most Excellent Order of the British</p>
<p class="abb1"><span class="abb2">KCB</span> Knight Commander of the Order of the Bath</p>
<p class="abb1"><span class="abb2">KCIE</span> Knight Commander of the Order of the Indian Empire</p>
<p class="abb1"><span class="abb2">KCMG</span> Knight Commander of St Michael and St George</p>
<p class="abb1"><span class="abb2">KCVO</span> Knight Commander of the Royal Victorian Order</p>
<p class="abb1"><span class="abb2">KGStJ</span> Knight of Grace of the Most Venerable Order of the Hospital of Saint John of Jerusalem</p>
<p class="abb1"><span class="abb2">Kia</span> Killed in action</p>
<p class="abb1"><span class="abb2">KJStJ</span> Knight of Justice of the Most Venerable Order of the Hospital of Saint John of Jerusalem</p>
<p class="abb1"><span class="abb2">Kms</span> Kilometres</p>
<p class="abb1"><span class="abb2">KStJ</span> Knight of the Most Venerable Order of the Hospital of Saint John of Jerusalem</p>
<p class="abb1"><span class="abb2">LAC</span> Leading Aircraftsman</p>
<p class="abb1"><span class="abb2">LAD</span> Light Aid Detachment</p>
<a id="page_xii"></a>
<p class="abb1"><span class="abb2">LCpl</span> Lance Corporal</p>
<p class="abb1"><span class="abb2">LCS(L)</span> Littoral Combat Ship/Landing Craft Support (Large)</p>
<p class="abb1"><span class="abb2">LG</span> London Gazette</p>
<p class="abb1"><span class="abb2">LL.B</span> Bachelor of Laws (Legum Baccalaureus)</p>
<p class="abb1"><span class="abb2">LMSSA</span> Licentiate in Medicine and Surgery of the Society of Apothecaries</p>
<p class="abb1"><span class="abb2">LRCP</span> Licentiate, Royal College of Physicians</p>
<p class="abb1"><span class="abb2">LST</span> Landing Ship Tank</p>
<p class="abb1"><span class="abb2">Lt</span> Lieutenant</p>
<p class="abb1"><span class="abb2">Lt Col</span> Lieutenant Colonel</p>
<p class="abb1"><span class="abb2">Lt Gen</span> Lieutenant General</p>
<p class="abb1"><span class="abb2">MA</span> Master of Arts</p>
<p class="abb1"><span class="abb2">Maj</span> Major</p>
<p class="abb1"><span class="abb2">Maj Gen</span> Major General</p>
<p class="abb1"><span class="abb2">MBA</span> Master of Business Administration</p>
<p class="abb1"><span class="abb2">MBE</span> Member of the Order of the British Empire</p>
<p class="abb1"><span class="abb2">MC</span> Military Cross</p>
<p class="abb1"><span class="abb2">MGC</span> Machine Gun Corps</p>
<p class="abb1"><span class="abb2">MID</span> Mentioned in Despatches</p>
<p class="abb1"><span class="abb2">MLC</span> Member of Legislative Council</p>
<p class="abb1"><span class="abb2">MM</span> Military Medal</p>
<p class="abb1"><span class="abb2">MO</span> Medical Officer</p>
<p class="abb1"><span class="abb2">MP</span> Member of Parliament</p>
<p class="abb1"><span class="abb2">MRCS</span> Member of the Royal College of Surgeons</p>
<p class="abb1"><span class="abb2">MS</span> Motor Ship</p>
<p class="abb1"><span class="abb2">MSM</span> Meritorious Service Medal</p>
<p class="abb1"><span class="abb2">MT</span> Motor Transport</p>
<p class="abb1"><span class="abb2">MVO</span> Member of the Royal Victorian Order</p>
<p class="abb1"><span class="abb2">NAAFI</span> Navy, Army and Air Force Institute</p>
<p class="abb1"><span class="abb2">NSRD</span> Nova Scotia Regiment Depot</p>
<p class="abb1"><span class="abb2">NSW</span> New South Wales</p>
<p class="abb1"><span class="abb2">NZEF</span> New Zealand Expeditionary Force</p>
<p class="abb1"><span class="abb2">OBE</span> Officer of the Order of the British Empire</p>
<p class="abb1"><span class="abb2">OC</span> Officer Commanding</p>
<p class="abb1"><span class="abb2">OStJ</span> Officer of the Most Venerable Order of the Hospital of Saint John</p>
<p class="abb1"><span class="abb2">of</span> Jerusalem</p>
<p class="abb1"><span class="abb2">OTC</span> Officers’ Training Corps</p>
<p class="abb1"><span class="abb2">P&amp;O</span> Pacific &amp; Orient Steam Navigation Co</p>
<p class="abb1"><span class="abb2">PC</span> Police Constable or Privy Counsellor</p>
<p class="abb1"><span class="abb2">PoW</span> Prisoner of War</p>
<p class="abb1"><span class="abb2">PPCLI</span> Princess Patricia’s Canadian Light Infantry</p>
<p class="abb1"><span class="abb2">PS</span> Paddle Steamer</p>
<p class="abb1"><span class="abb2">Pte</span> Private</p>
<a id="page_xiii"></a>
<p class="abb1"><span class="abb2">QC</span> Queen’s Counsel</p>
<p class="abb1"><span class="abb2">RA</span> Royal Artillery or Royal Academy</p>
<p class="abb1"><span class="abb2">RAAF</span> Royal Auxiliary Air Force or Royal Australian Air Force</p>
<p class="abb1"><span class="abb2">RAF</span> Royal Air Force</p>
<p class="abb1"><span class="abb2">RAMC</span> Royal Army Medical Corps</p>
<p class="abb1"><span class="abb2">RAOC</span> Royal Army Ordnance Corps</p>
<p class="abb1"><span class="abb2">RAP</span> Regimental Aid Post</p>
<p class="abb1"><span class="abb2">RASC</span> Royal Army Service Corps</p>
<p class="abb1"><span class="abb2">RCA</span> Royal Canadian Artillery</p>
<p class="abb1"><span class="abb2">RCAF</span> Royal Canadian Air Force</p>
<p class="abb1"><span class="abb2">RCAMC</span> Royal Canadian Army Medical Corps</p>
<p class="abb1"><span class="abb2">RCR</span> Royal Canadian Regiment</p>
<p class="abb1"><span class="abb2">RFA</span> Royal Field Artillery</p>
<p class="abb1"><span class="abb2">RFC</span> Royal Flying Corps</p>
<p class="abb1"><span class="abb2">RGA</span> Royal Garrison Artillery</p>
<p class="abb1"><span class="abb2">RHA</span> Royal Horse Artillery</p>
<p class="abb1"><span class="abb2">RMLI</span> Royal Marine Light Infantry</p>
<p class="abb1"><span class="abb2">RMS</span> Royal Mail Ship/Steamer</p>
<p class="abb1"><span class="abb2">RN</span> Royal Navy</p>
<p class="abb1"><span class="abb2">RNAS</span> Royal Naval Air Service</p>
<p class="abb1"><span class="abb2">RND</span> Royal Naval Division</p>
<p class="abb1"><span class="abb2">RNVR</span> Royal Naval Volunteer Reserve</p>
<p class="abb1"><span class="abb2">RQMS</span> Regimental Quartermaster Sergeant</p>
<p class="abb1"><span class="abb2">RSA</span> Returned and Services’ Association (NZ)</p>
<p class="abb1"><span class="abb2">RSL</span> Returned and Services League (Australia)</p>
<p class="abb1"><span class="abb2">RSM</span> Regimental Sergeant Major</p>
<p class="abb1"><span class="abb2">RTD</span> Reception Training Depot</p>
<p class="abb1"><span class="abb2">RTO</span> Railway Transport Officer</p>
<p class="abb1"><span class="abb2">SA</span> South Australia</p>
<p class="abb1"><span class="abb2">Sgt</span> Sergeant</p>
<p class="abb1"><span class="abb2">SMLE</span> Short Magazine Lee Enfield</p>
<p class="abb1"><span class="abb2">SNCO</span> Senior non-commissioned officers</p>
<p class="abb1"><span class="abb2">Spr</span> Sapper</p>
<p class="abb1"><span class="abb2">SS</span> Steam Ship</p>
<p class="abb1"><span class="abb2">SSM</span> Squadron Sergeant Major</p>
<p class="abb1"><span class="abb2">TA</span> Territorial Army</p>
<p class="abb1"><span class="abb2">TD</span> Territorial Decoration</p>
<p class="abb1"><span class="abb2">TF</span> Territorial Force</p>
<p class="abb1"><span class="abb2">Tr</span> Trench</p>
<p class="abb1"><span class="abb2">TSS</span> Twin Screw Steamer</p>
<p class="abb1"><span class="abb2">UNESCO</span> United Nations Educational, Scientific and Cultural Organization</p>
<p class="abb1"><span class="abb2">USAAF</span> United States Army Air Force</p>
<a id="page_xiv"></a>
<p class="abb1"><span class="abb2">USAT</span> United States Army Transport</p>
<p class="abb1"><span class="abb2">USS</span> United States Ship</p>
<p class="abb1"><span class="abb2">VAD</span> Voluntary Aid Detachment</p>
<p class="abb1"><span class="abb2">VC</span> Victoria Cross</p>
<p class="abb1"><span class="abb2">VD</span> Volunteer Decoration or venereal disease</p>
<p class="abb1"><span class="abb2">VDC</span> Voluntary Defence Corps</p>
<p class="abb1"><span class="abb2">WA</span> Western Australia</p>
<p class="abb1"><span class="abb2">WO1 or 2</span> or 2 Warrant Officer Class 1 or 2</p>
<p class="abb1"><span class="abb2">WT</span> Wireless Telegraphy</p>
<p class="abb1"><span class="abb2">YWCA</span> Young Women’s Christian Association</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Abbreviations.vue?097d271d